import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Select from 'components/new_ui/Select';
import Form from 'react-bootstrap5/Form';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Info from './Info';
import Payments from './Payments';
import Invoices from './Invoices';

export default function WithCycles({ cycles }) {
  const [cycle, setCycle] = useState(null);

  const selectOptions = cycles.map((item) => ({
    value: item.id,
    label: item.attributes.name,
    cycle: item,
  }));

  useEffect(() => {
    if (cycles !== null && cycles.length > 0) {
      setCycle(() => {
        const [itemCycle = cycles[0]] = cycles.filter(
          (item) => item.attributes.current === 'Yes',
        );
        return itemCycle;
      });
    }
  }, [cycles]);

  if (cycle === null) {
    return (
      <LoadingPlaceholder text="Loading..." className="py-5" />
    );
  }

  return (
    <>
      <h3>Benefit Plan Contribution</h3>
      <Form.Group controlId="memberCycle">
        <Form.Label>
          Select Enrollment
        </Form.Label>
        <Select
          className="col-md-3"
          id="choose-member-cycle"
          placeholder="Choose Cycle"
          value={
              selectOptions.find((option) => option.value === cycle.id)
          }
          options={selectOptions}
          onChange={(option) => {
            if (option?.cycle) {
              setCycle(option.cycle);
            }
          }}
        />
      </Form.Group>

      <Info cycle={cycle} />
      <Payments cycle={cycle} />
      <Invoices cycle={cycle} />
    </>
  );
}

WithCycles.propTypes = {
  cycles: PropTypes.arrayOf(PropTypes.object).isRequired,
};
